import { useQuery } from "@tanstack/react-query";
import { getLevels } from ".";

export default function useLevels() {
  const queryData = useQuery({
    queryKey: ["levels"],
    queryFn: getLevels,
    select: ({ data }) => data.data || [],
  });

  return queryData;
}
